"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const RecordingGroupGridRow_1 = __importDefault(require("@Components/MatchComponents/v2/RecordingGroupGridRow"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const recording_group_category_1 = __importDefault(require("@App/enum/recording-group-category"));
const mobx_react_1 = require("mobx-react");
const RecordingGroupGridHeader_1 = __importDefault(require("@Components/MatchComponents/v2/RecordingGroupGridHeader"));
const RecordingGroupGrid = (props) => {
    var _a;
    const params = (0, react_router_dom_1.useParams)();
    if (!params.submissionId) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const { matchHistoryStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { foundStatus } = props;
    const foundData = matchHistoryStore.recordingGroupsDetails[foundStatus];
    const isPendingStatus = foundStatus === recording_group_category_1.default.Pending;
    const isRejectedStatus = foundStatus === recording_group_category_1.default.Rejected;
    const gridClassNames = (0, clsx_1.default)('recording-group-grid', isPendingStatus && 'pending-data', isRejectedStatus && 'rejected-data');
    return (react_1.default.createElement("div", { className: gridClassNames },
        react_1.default.createElement(RecordingGroupGridHeader_1.default, { isPendingStatus: isPendingStatus, isRejectedStatus: isRejectedStatus }), (_a = foundData === null || foundData === void 0 ? void 0 : foundData.content) === null || _a === void 0 ? void 0 :
        _a.map((recordingGroupDetail, idx) => (react_1.default.createElement(RecordingGroupGridRow_1.default, { recordingGroup: recordingGroupDetail, key: idx, showValue: isPendingStatus, showRejectedReason: isRejectedStatus })))));
};
exports.default = (0, mobx_react_1.observer)(RecordingGroupGrid);
